import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { getIsMobile } from 'Store/Screen/selectors';
import { getOrderSeats, getSeatsTotalPrice } from 'Store/Order/selectors';
import OrderSeatSummary, { OrderSeatList } from './OrderSeatSummary';
import OrderSeat from './OrderSeat';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';
import { getIsTimeSlot } from 'Components/OrderItem/Redux/selectors';

interface IPropsInternal {
  isMobile: boolean;
  isTimeSlot: boolean;
  totalPrice: number;
  orderSeats: Julius.Website.OrderSeatViewModel[];
}

type Props = IPropsInternal;

class OrderSeatSummaryContainer extends React.PureComponent<Props> {
  private wrapperRef: HTMLElement;

  componentWillReceiveProps(nextProps: Props) {
    if (this.props.totalPrice !== nextProps.totalPrice) {
      this.onNewTotalPrice();
    }
  }

  setRef = (node: HTMLElement) => {
    this.wrapperRef = node;
  }

  onNewTotalPrice = () => {
    this.wrapperRef.scrollIntoView({ block: 'end', behavior: 'smooth' });
  }

  render() {

    const { orderSeats } = this.props;

    if (!orderSeats || !orderSeats.length) {
      return null;
    }

    return (
      <WrapperBox>
        <OrderSeatSummary 
          setRef={ this.setRef } 
          totalPrice={ this.props.totalPrice }
        >
          <OrderSeatList>
            { orderSeats.map(s => 
              <OrderSeat 
                key={ s.seatID } 
                isMobile={ this.props.isMobile }
                isTimeSlot={ this.props.isTimeSlot }
                orderSeats={ s }
              />)
            }
          </OrderSeatList>
        </OrderSeatSummary>
      </WrapperBox>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
  }, dispatch);
};

const mapStateToProps = (state: IStore) => {
  return {
    isMobile: getIsMobile(state),
    isTimeSlot: getIsTimeSlot(state),
    totalPrice: getSeatsTotalPrice(state),
    orderSeats: getOrderSeats(state),
  };
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(OrderSeatSummaryContainer);


// WEBPACK FOOTER //
// ./src/components/OrderSeatSummary/OrderSeatSummaryContainer.tsx